// TODO: Rename when backend defines the final role names
export enum UserRole {
  SuperAdmin = 'aws.cognito.signin.user.admin',
  CustomerServiceDepartment = 'CSD',
  PhysicianNetwork = 'PN',
  None = 'None',
}

export enum Role {
  SuperUser = 'superuser',
  Admin = 'admin',
  Physician = 'physician',
  Customer = 'user',
  EventManager = 'eventmanager',
}
export interface SignInInput {
  email: string;
  password: string;
}

export interface SignInResponse {
  idToken: {
    jwtToken: string;
    payload: {
      sub: string;
      auth_time: number;
      exp: number;
      iat: number;
      email: string;
      given_name: string;
      family_name: string;
      'custom:roles': string;
    };
  };
  refreshToken: {
    token: string;
  };
  accessToken: {
    jwtToken: string;
    payload: {
      sub: string;
      scope: UserRole;
      auth_time: number;
      exp: number;
      iat: number;
      username: string;
    };
  };
  status: string;
  id: number;
}

export interface RefreshTokenInput {
  email: string;
  refreshToken: string;
}

export interface InitiateResetPasswordInput {
  email: string;
}

export interface InitiateResetPasswordResponse {
  status: string;
  msg: string;
}

export interface ConfirmResetPasswordInput extends InitiateResetPasswordInput {
  code: string;
  newPassword: string;
}

export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female',
}

export interface AccountDetailsInput {
  email: string;
  password: string;
}

export interface PersonalInformationInput {
  firstName: string;
  lastName: string;
  middleName?: string;
  birthdate: Date;
  gender: string;
}

export interface SignUpInput
  extends AccountDetailsInput,
    PersonalInformationInput {}

export interface CodeVerificationInput {
  email: string;
  code: string;
}

export interface ResendCodeInput {
  email: string;
}

export interface ValidateEmailInput {
  email: string;
}
